<template>
  <div
    id="nav-buttons"
    class="registration-field"
  >
    <button
      id="next-button"
      ref="button"
      class="submit-button full-width"
      type="submit"
      :disabled="loading"
    >
      <div
        v-if="loading && useSpinner"
        class="load-container load3"
      >
        <div class="loader" />
      </div>
      <template v-if="!loading || !useSpinner">
        {{ text }}
      </template>
    </button>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  props: {
    useSpinner: {
      type:    Boolean,
      default: true,
    },
    text: {
      type:    String,
      default: 'Avançar 〉',
    },
  },
  computed: {
    submittingData:     sync('registration/submittingRegData'),
    awaitingNavigation: sync('awaitingNavigation'),
    loading() {
      return this.submittingData || this.awaitingNavigation;
    },
  },
  methods: {
    shakeDisableButton() {
      const { button } = this.$refs;
      button.classList.add('shake-disable');
      button.addEventListener('animationend', () => {
        button.classList.remove('shake-disable');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.load-container {
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.load3 .loader {
  font-size: 4px;
  margin: 5px auto;
  text-indent: -9999em;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #333333;
  background: -moz-linear-gradient(
    left,
    #333333 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #333333 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #333333 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #333333 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #333333 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.load3 .loader:before {
  width: 50%;
  height: 50%;
  background: #333333;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.load3 .loader:after {
  background: #f5bf05;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
  }
}
@keyframes load3 {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

#next-button {
  transition: none;
  &:focus {
    outline: none;
  }
}
#next-button.shake-disable {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  cursor: not-allowed;
}
.full-width {
  width: 100% !important;
  #next-button {
    margin: 0;
    width: 100%;
  }
}
</style>
